import { motion } from 'framer-motion';
import { useBreadcrumbs } from 'global/cnr/contexts/useHelpers/useBreadcrumbs';
import _ from 'lodash';
import { useEffect, useMemo, useState } from 'react';
import { Icon } from 'semantic-ui-react';
import Wrapper, { wrapperTypes } from './Wrapper';
import ItemMenuSquares, { _imsTypes } from './ItemMenuSquares';

const itemTransition = { duration: 0.25, ease: 'easeOut' };

/**
 * 
 * @param {*} param0 
 * @returns 
 */
export const SquareGroup = ({
  direction,
  isMain,
  baseContent,
  baseKey,
  handleSelect,
}) => {

  const [allGroups, setAllGroups] = useState([])

  useEffect(() => {
    const baseKeys = _.keys(baseContent)
    const _allGroups = []
    _allGroups.push({
      key: baseKey,
      value: '',
      caption: _.startCase(baseKey),
      content: baseKeys
    })
    setAllGroups(_allGroups)
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [baseContent]);

  const addToGroup = (group) => {
    const _allGroups = _.clone(allGroups)
    _allGroups.push(group)
    setAllGroups(_allGroups)
  }

  const goBack = () => {
    const _allGroups = _.clone(allGroups)
    if (_allGroups.length <= 1) { return; }
    const all_groups = _allGroups.slice(0, -1)
    setAllGroups(all_groups)
  }

  const goBackTo = (index) => {
    const _allGroups = _.clone(allGroups)
    if (index < 0 || index >= _allGroups.length) return;
    if (_allGroups.length <= 1) return; // ⛔ root protected 
    const all_groupz = _allGroups.slice(0, index + 1)
    setAllGroups(all_groupz)
  }

  const backLinks = useMemo(() => {
    const bl = _.map(
      allGroups.slice(0, -1),
      (group, index) => (
        {
          key: group.key || 0,
          caption: group.caption || _.startCase(group?.key) || 'App Settings'
        }
      )
    );
    return bl
  }, [allGroups])

  const bcrb = useBreadcrumbs({ items: backLinks, onClick: goBackTo })

  const onClick_base = (baseType) => {
    const content = handleSelect(baseType)
    addToGroup({
      key: baseType,
      value: '',
      caption: _.startCase(baseType),
      content
    })
  }

  const getX = (direction) => {
    switch (direction) {
      case 'left':
        return -20; // enters from left
      case 'right':
        return 20;  // enters from right
      default:
        return 0;
    }
  };

  const motion_wrapper = (content, formKey) => <motion.div
    className={'mwsw sg'}
    key={formKey || 'key'}
    layout
    initial={{ opacity: 0, y: 0, x: getX(direction) }}
    animate={{ opacity: 1, y: 0, x: 0 }}
    exit={{ opacity: 0, y: 0, x: getX(direction) }}
    transition={itemTransition}>
    {content}
  </motion.div>

  const header_top = () => {
    const currentGroup = allGroups?.[allGroups.length - 1]
    const { caption, key } = currentGroup ?? {}
    const _caption = caption || _.startCase(key)
    return <div className='swr-header'>
      {bcrb}
      <div className='swr-header-cap'><Icon color={'blue'} name='arrow left' onClick={(e) => goBack()}></Icon>{_caption}</div>
    </div>
  }

  const squares_base = (menuItems) => <ItemMenuSquares menuItems={menuItems} imsType={_imsTypes.normal} onClick={onClick_base} />

  const content_active = () => {
    const currentGroup = allGroups?.[allGroups.length - 1]
    const { key, content } = currentGroup ?? {}
    switch (key) {
      case baseKey:
        return squares_base(content)
      default:
        return content
    }
  }


  const wrapper = () => <Wrapper
    header={!isMain && header_top()}
    content={content_active()}
    wrapperType={wrapperTypes.paddedHeaderAndFooter}
    noMid={true}
  />

  return wrapper()

}
